export abstract class AbstractCustomFieldConfig {
    abstract customFieldKey: string;
    abstract customFieldTitle: string;
}
